import React, { ReactElement, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { BiArrowBack } from 'react-icons/all';

export type PropsDEnteteDePage = {
    texte?: ReactNode;
    cacherBoutonRetour?: boolean;
    iconSize?: string;
};

export default function EnteteDePage(props: PropsDEnteteDePage): ReactElement {
    const { texte, cacherBoutonRetour, iconSize } = props;
    const navigate = useNavigate();
    function goBack() {
        navigate(-1);
    }
    return (
        <div className="d-flex align-items-center">
            {cacherBoutonRetour ? null : (
                <Button size="lg" variant="link" onClick={goBack} style={{ lineHeight: 'normal' }}>
                    <BiArrowBack size={iconSize} />
                </Button>
            )}
            <div style={{ fontSize: '1.7em' }}>{texte}</div>
        </div>
    );
}
